import React from "react";
import { Button, ButtonGroup, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faPen, faTrash } from "@fortawesome/free-solid-svg-icons";

const HardwareActionCell = props => (
  <Row style={{ display: "block" }}>
    <div className="floatRight">
      <ButtonGroup size="sm">
        {props.hasRemarks ? <Button className="btn-black" onClick={props.onShowRemarks}>
          <FontAwesomeIcon icon={faInfoCircle} size="1x" />
        </Button> : ""}
        <Button className="btn-green" onClick={props.onEdit}>
          <FontAwesomeIcon icon={faPen} size="1x" />
        </Button>
        <Button className="btn-red" onClick={props.onDelete}>
          <FontAwesomeIcon icon={faTrash} size="1x" />
        </Button>
      </ButtonGroup>
    </div>
  </Row>
);

export default HardwareActionCell;
